import axios from 'axios';

declare module 'axios' {
  interface AxiosRequestConfig { mesombNavigation?: boolean; }
}

// Shared by the three entry points; setupAxios installs the API boundary.
const api = Object.assign(axios.create(), {
  isCancel: axios.isCancel,
  isAxiosError: axios.isAxiosError,
  CanceledError: axios.CanceledError,
  AxiosError: axios.AxiosError,
});
export default api;
